import React, { useState, useEffect } from 'react';
import { TextField, FormControlLabel, Checkbox, Box, Typography, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function SubAccountantFormModal({
  isOpen,
  onClose,
  onOverlayClick,
  onContainerClick,
  isEditMode,
  isNewSubAccountant,
  selectedSubAccountant,
  setSelectedSubAccountant,
  isSubAccountantForClient,
  setIsSubAccountantForClient,
  handleAddSubAccountant,
  handleSaveChanges,
  prepareDelete,
  direction,
  allFieldsFilled,
  // Permissions props
  availablePermissions = [],
  subAccountantPermissions = [],
  onPermissionToggle,
  accountantId,
  token,
}) {
  const { i18n, t } = useTranslation();

  if (!isOpen || !selectedSubAccountant) return null;

  return (
    <div className="sub-popup-hamburger-overlay" onClick={onOverlayClick}>
      <div className="sub-add-client__container sub-add-client__container--scrollable" onClick={onContainerClick}>
        <div className={`sub-add-client-content ${direction}`}>
          <div className="title-and-buttons">
            {isEditMode ? (
              <>
                <h2 className='centered-heading'>{t('EditSubAccountant')}</h2>
                <button className='row-buttons subEditDeleteButton' onClick={prepareDelete}>
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="23" viewBox="0 0 19 23" fill="none">
                    <path d="M13.7143 12.7139C16.3179 12.7139 18.4286 14.8245 18.4286 17.4282C18.4286 20.0318 16.3179 22.1424 13.7143 22.1424C11.1107 22.1424 9.00002 20.0318 9.00002 17.4282C9.00002 14.8245 11.1107 12.7139 13.7143 12.7139ZM9.00002 0.713867C10.8362 0.713867 12.3352 2.15727 12.4244 3.97132L12.4286 4.14244H16.7143C17.1877 4.14244 17.5714 4.52619 17.5714 4.99958C17.5714 5.43916 17.2406 5.80145 16.8143 5.85096L16.7143 5.85672H15.9866L15.4772 12.1414C14.9232 11.9567 14.3304 11.8567 13.7143 11.8567C10.6373 11.8567 8.14287 14.3511 8.14287 17.4282C8.14287 18.9255 8.73355 20.2849 9.69461 21.286L6.22853 21.2853C4.55406 21.2853 3.16009 19.9998 3.02476 18.3308L2.01259 5.85672H1.28573C0.846158 5.85672 0.483868 5.52583 0.434355 5.09954L0.428589 4.99958C0.428589 4.56001 0.759481 4.19772 1.18577 4.14821L1.28573 4.14244H5.57145C5.57145 2.24889 7.10647 0.713867 9.00002 0.713867ZM12.1979 15.306L12.1386 15.2564C11.9924 15.1551 11.7974 15.1551 11.6512 15.2564L11.5918 15.306L11.5423 15.3653C11.441 15.5115 11.441 15.7066 11.5423 15.8527L11.5918 15.9121L13.1086 17.4287L11.5941 18.9431L11.5445 19.0025C11.4432 19.1487 11.4432 19.3437 11.5445 19.4899L11.5941 19.5492L11.6534 19.5988C11.7996 19.7001 11.9946 19.7001 12.1408 19.5988L12.2002 19.5492L13.7146 18.0347L15.2309 19.5512L15.2903 19.6007C15.4364 19.702 15.6315 19.702 15.7777 19.6007L15.837 19.5512L15.8866 19.4918C15.9879 19.3457 15.9879 19.1506 15.8866 19.0044L15.837 18.9451L14.3206 17.4287L15.8394 15.9121L15.889 15.8528C15.9902 15.7066 15.9902 15.5115 15.889 15.3654L15.8394 15.306L15.78 15.2564C15.6339 15.1552 15.4388 15.1552 15.2927 15.2564L15.2333 15.306L13.7146 16.8227L12.1979 15.306ZM9.00002 2.42815C8.09628 2.42815 7.35588 3.12748 7.29043 4.0145L7.28573 4.14244H10.7143L10.7096 4.0145C10.6442 3.12748 9.90376 2.42815 9.00002 2.42815Z" fill="#FC2807" />
                </svg>
                </button>
              </>
            ) : (
              <h2 className='centered-heading'>{t('addSubAccountant')}</h2>
            )}
          </div>

          <Box className="sub-add-client__body" sx={{ overflowY: 'auto', maxHeight: 'calc(100vh - 200px)', pr: 0.5 }}>
          {/* ——— Section: Basic info ——— */}
          <Box component="section" sx={{ mb: 3 }}>
          {/* Name */}
          <div className="form-row-item subAcc-full-width">
            <div className="form-row-item-title">
              {t('Name')}<span className="required-asterisk">*</span>
            </div>
            <TextField
              fullWidth
              placeholder={t('enterName')}
              value={selectedSubAccountant.name}
              onChange={(e) => setSelectedSubAccountant({ ...selectedSubAccountant, name: e.target.value })}
              variant="standard"
              InputProps={{
                disableUnderline: true,
                sx: inputStyle,
              }}
              inputProps={{ style: { textAlign: direction === 'ltr' ? 'left' : 'right' } }}
            />
          </div>

          {/* Accountant ID */}
          <div className="form-row-item subAcc-full-width">
            <div className="form-row-item-title">
              {t('AccountantID')}<span className="required-asterisk">*</span>
            </div>
            <TextField
              fullWidth
              placeholder={t('enterSubAccountantId')}
              value={selectedSubAccountant.subAccountantId}
              onChange={(e) => setSelectedSubAccountant({ ...selectedSubAccountant, subAccountantId: e.target.value })}
              type="number"
              variant="standard"
              disabled={!isNewSubAccountant}
              InputProps={{
                disableUnderline: true,
                sx: inputStyle,
              }}
              inputProps={{ style: { textAlign: direction === 'ltr' ? 'left' : 'right' } }}
            />
          </div>

          {/* Phone Number */}
          <div className="form-row-item subAcc-full-width">
            <div className="form-row-item-title">
              {t('phoneNumber')}<span className="required-asterisk">*</span>
            </div>
            <TextField
              fullWidth
              placeholder={t('enterPhoneNumber')}
              value={selectedSubAccountant.phoneNumber}
              onChange={(e) => setSelectedSubAccountant({ ...selectedSubAccountant, phoneNumber: e.target.value })}
              type="number"
              variant="standard"
              InputProps={{
                disableUnderline: true,
                sx: inputStyle,
              }}
              inputProps={{ style: { textAlign: direction === 'ltr' ? 'left' : 'right' } }}
            />
          </div>

          {/* Email */}
          <div className="form-row-item subAcc-full-width">
            <div className="form-row-item-title">
              {t('email')}<span className="required-asterisk">*</span>
            </div>
            <TextField
              fullWidth
              placeholder={t('enterEmail')}
              value={selectedSubAccountant.email}
              onChange={(e) => setSelectedSubAccountant({ ...selectedSubAccountant, email: e.target.value })}
              variant="standard"
              InputProps={{
                disableUnderline: true,
                sx: inputStyle,
              }}
              inputProps={{ style: { textAlign: direction === 'ltr' ? 'left' : 'right' } }}
            />
          </div>

          {/* Price Per Hour */}
          <div className="form-row-item subAcc-full-width">
            <div className="form-row-item-title">
              {t('HourlyCost') || 'Hourly Cost'}
            </div>
            <TextField
              fullWidth
              placeholder={t('enterHourlyCost') || 'Enter hourly cost'}
              value={selectedSubAccountant.pricePerHour || ''}
              onChange={(e) => setSelectedSubAccountant({ ...selectedSubAccountant, pricePerHour: e.target.value ? parseFloat(e.target.value) : null })}
              type="number"
              variant="standard"
              InputProps={{
                disableUnderline: true,
                sx: inputStyle,
                startAdornment: <span style={{ marginRight: '8px', color: '#666' }}>₪</span>,
              }}
              inputProps={{ 
                style: { textAlign: direction === 'ltr' ? 'left' : 'right' },
                min: 0,
                step: 0.01
              }}
            />
          </div>

          {/* Password */}
          {isNewSubAccountant && (
            <div className="form-row-item subAcc-full-width">
              <div className="form-row-item-title">
                {t('enterPassword')}<span className="required-asterisk">*</span>
              </div>
              <TextField
                fullWidth
                placeholder={t('enterPassword')}
                value={selectedSubAccountant.password}
                onChange={(e) => setSelectedSubAccountant({ ...selectedSubAccountant, password: e.target.value })}
                type="password"
                variant="standard"
                InputProps={{
                  disableUnderline: true,
                  sx: inputStyle,
                }}
                inputProps={{ style: { textAlign: direction === 'ltr' ? 'left' : 'right' } }}
              />
            </div>
          )}

          {/* Is SubAccountant for Client */}
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isSubAccountantForClient}
                  onChange={(e) => setIsSubAccountantForClient(e.target.checked)}
                  color="primary"
                />
              }
              label={t('IsSubAccountantForClient')}
            />
          </div>
          </Box>

          {/* ——— Section: Permissions ——— */}
          {!isNewSubAccountant && availablePermissions && availablePermissions.length > 0 && (
            <Box component="section" sx={{ mb: 3 }}>
              <Divider sx={{ mb: 2 }} />
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1.5 }}>
                {t('Permissions')}
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, pl: 0.5 }}>
                {availablePermissions.map((permission) => {
                  const isChecked = subAccountantPermissions.some(
                    (p) => p.permissionId === permission.permissionId
                  );
                  return (
                    <FormControlLabel
                      key={permission.permissionId}
                      control={
                        <Checkbox
                          checked={isChecked}
                          onChange={() => onPermissionToggle && onPermissionToggle(permission.permissionId)}
                          color="primary"
                        />
                      }
                      label={t(permission.name) || permission.name}
                    />
                  );
                })}
              </Box>
            </Box>
          )}

          </Box>

          {/* Buttons — fixed at bottom, not inside scroll */}
          <div className="sub-button-container">
            <button className="sub-close-subAcc-content-button" onClick={onClose}>
              {t('close')}
            </button>
            <button
              className={`sub-add-subAcc-content-button ${!allFieldsFilled ? "button-disabled" : ""}`}
              disabled={!allFieldsFilled}
              onClick={isNewSubAccountant ? handleAddSubAccountant : handleSaveChanges}
            >
              {t('save')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

const inputStyle = {
  height: '48px',
  padding: '0 10px',
  borderRadius: '8px',
  background: '#F5F5F6',
  border: '1px solid transparent',
  '&:focus-within': {
    border: '2px solid var(--Foundation-Blue-Normal, #304FFF)',
  },
};
